// @flow
import * as React from 'react';
import Box from 'sail/Box';
import Card from 'sail/Card';
import {CodeBlock, OnlyRenderOnClient} from 'docs/components';
import classNames from 'classnames';
import {componentToExamples} from './examples';
import type {TailorComponentName} from './examples';
import './TailorExample.scss';

type TailorExampleProps = {|
  component: TailorComponentName,
  children: React.Node,
  example: string,
  hideSourceCode: boolean,
  showBackground: boolean,
  fill: boolean,
|};

// This is a WIP. See http://go/tailor-docs-journal

export const TailorExample = ({
  component,
  children,
  example,
  showBackground,
  fill,
  hideSourceCode = false,
}: TailorExampleProps) => {
  const {rendered, source} =
    componentToExamples[component] && componentToExamples[component][example]
      ? componentToExamples[component][example]
      : {};

  if (!rendered || !source) {
    return null;
  }

  return (
    <Box className="ComponentExample" margin={{top: 24, bottom: 24}}>
      <Box>
        <Card radius="top" shadow="keyline">
          <Box
            className={'ComponentExample-PreviewOuterContainer'}
            padding={{horizontal: 20, vertical: 32}}
          >
            {/* Sail Next does not support SSR quite yet, so we only render on client. */}
            <OnlyRenderOnClient>
              <div
                className={classNames(
                  'ComponentExample-PreviewInnerContainer',
                  {
                    'ComponentExample-PreviewInnerContainer-background': showBackground,
                  },
                )}
              >
                {rendered}
              </div>
            </OnlyRenderOnClient>
          </Box>
        </Card>
      </Box>
      {!hideSourceCode && (
        <Box className="ComponentExample-CodeContainer">
          <CodeBlock numbered={false} language="jsx">
            {`${source}\n`}
          </CodeBlock>
        </Box>
      )}
    </Box>
  );
};
